function Score() {

    this.name = 'score';
}

export {Score};
